import { createFileRoute } from '@tanstack/react-router'

import { forbiddenErrorComponent, requirePermission } from '@/lib/routeGuards'
import { Secrets } from '@/pages/Settings/Secrets/Secrets'
import { secretsSearchSchema } from '@/pages/Settings/Secrets/secretsSearchSchema'

export const Route = createFileRoute('/_app/settings/secrets')({
  component: Secrets,
  validateSearch: secretsSearchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.permissions, 'secrets:system')
  },
  errorComponent: forbiddenErrorComponent,
})
